import React, { useState,useEffect } from 'react';
import NavBar2 from '../Shared/NavBar2/NavBar2';
import './Pages.css';
const Cart = () => {
    const [counter, setCounter] = useState(0);
    const [cart, setCart] = useState([]);
  useEffect(() => {
    fetch('https://carame-cake-server-site.vercel.app/addToCart1')
    .then(res => res.json())
    .then(data => setCart(data))
  }, []);
    //increase counter
    const increase = () => {
        setCounter(count => count + 1);
    };
    //decrease counter
    const decrease = () => {
        if (counter > 0) {
            setCounter(count => count - 1);
        }
    };
    return (
        <>
            <NavBar2 />
            <div className='pt-4'></div>
            <h1 className='cart_bg mt-5 p-5'>CART({cart.length})</h1>
            {/* table */}
            <div className="container">
                <table class="table">
                    <thead>
                        <tr>
                            <th scope="col"></th>
                            <th scope="col"></th>
                            <th scope="col">Product</th>
                            <th scope="col">Price</th>
                            <th scope="col">Quantity</th>
                            <th scope="col">Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th scope="row">
                                <img width="15px" src="https://i.ibb.co/Y0RwZqV/delete-sign.png" alt="" />
                            </th>
                            <td>
                                <img width="100px" className="img-fluid" src="https://i.ibb.co/fYKRd16/shop-7-img-300x300.jpg" alt="" />
                            </td>
                            <td>Dark chocolate</td>
                            <td>€12.00</td>
                            <td>
                                <div>
                                    <div className="d-flex">
                                        <input
                                            style=
                                            {{ width: "40px", textAlign: "center" }}
                                            type="text"
                                            className="js-qty__num"
                                            value={counter}
                                            min="1"
                                            data-id=""
                                            aria-label="quantity"
                                            pattern="[0-9]*"
                                            name="quantity"
                                            id="Quantity"
                                        />
                                        <div>
                                            <button
                                                type="button"
                                                className="btn7"
                                                data-id=""
                                                data-qty="11"
                                                onClick={increase}
                                            >
                                                <span className="fa fa-plus"></span>
                                            </button>
                                            <br />
                                            <button
                                                type="button"
                                                className="btn7"
                                                data-id=""
                                                data-qty="0"
                                                onClick={decrease}
                                            >
                                                <span className="fa fa-minus"></span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td>€12.00</td>
                        </tr>
                    </tbody>
                </table>
            </div>






        </>
    );
};

export default Cart;